export default defineNuxtRouteMiddleware(to => {
  const { useConsumerTheme, useProTheme } = useThemes()

  const setThemeBasedOnRoute = () => {
    if (to.path.startsWith('/pro')) {
      setPageLayout('pro')
      useProTheme()
    }
    else {
      useConsumerTheme()
    }
  }

  setThemeBasedOnRoute()

  watchEffect(() => {
    setThemeBasedOnRoute()
  })
})
